(function($){
    'use strict';
 
	$('.js-tabs-filter').each(function () {
        var $tabFilter = $(this),
        	$tabLink = $tabFilter.find('a'),
        	$tabPanel = $tabFilter.closest('.js-tabs').find('.js-tabs-panel[data-tab="' + $tabFilter.attr('data-tab') + '"]');

    	if(!$tabFilter.hasClass('external')) {
        	$tabLink.click(function() {
            	if(!$tabFilter.hasClass('active')) {
            		$tabFilter.siblings().removeClass('active');
            		$tabFilter.addClass('active');

					$tabPanel.siblings().removeClass('active');
					$tabPanel.addClass('active');
            	}

        		return false;
        	});
        }
     });

	$('.js-tabs').each(function() {
		var $tab = $(this);
		filterTabsNavigation($tab);
	})

	function filterTabsNavigation($tabs) { /* Activates sliding functionality for silter tabs when they don't fit on the screen */
		var $tabFiltersWrapper = $tabs.find('.js-tabs-filters-wrapper'),
			$tabFiltersContent = $tabs.find('.js-tabs-filters-content'),
			$tabFiltersLeft = $tabs.find('.js-tabs-button-left'),
			$tabFiltersRight = $tabs.find('.js-tabs-button-right'),
			$tabFiltersSettings = {
			    filtersTravelling: false,
			    filtersTravelDirection: '',
				filtersTravelDistance: 150
			},
			$tabFiltersLastPosition = 0,
			$tabFiltersTicking = false;

		$tabFiltersWrapper.attr("data-overflowing", determineOverflow($tabFiltersContent, $tabFiltersWrapper));

        $(window).resize(function() {
			$tabFiltersWrapper.attr("data-overflowing", determineOverflow($tabFiltersContent, $tabFiltersWrapper));
        });

		function setDataOverflowing() {
		    $tabFiltersWrapper.attr("data-overflowing", determineOverflow($tabFiltersContent, $tabFiltersWrapper));
		}

		$tabFiltersWrapper.scroll(function() {
		    $tabFiltersLastPosition = window.scrollY;

		    if (!$tabFiltersTicking) {
		        window.requestAnimationFrame(function() {
		            setDataOverflowing($tabFiltersLastPosition);
		            $tabFiltersTicking = false;
		        });
		    }
		    $tabFiltersTicking = true;
		});


		$tabFiltersLeft.click(function() {
		    if ($tabFiltersSettings.filtersTravelling === true) {
		        return;
		    }

		    if (determineOverflow($tabFiltersContent, $tabFiltersWrapper) === "left" || determineOverflow($tabFiltersContent, $tabFiltersWrapper) === "both") {
		        var availableScrollLeft = $tabFiltersWrapper[0].scrollLeft;
		        if (availableScrollLeft < $tabFiltersSettings.filtersTravelDistance * 2) {
		            $tabFiltersContent.css('transform', "translateX(" + availableScrollLeft + "px)");
		        } else {
		            $tabFiltersContent.css('transform', "translateX(" + $tabFiltersSettings.filtersTravelDistance + "px)");
		        }

		        $tabFiltersContent.removeClass("tabs__filters-content-no-transition");
		        $tabFiltersSettings.filtersTravelDirection = "left";
		        $tabFiltersSettings.filtersTravelling = true;
		    }

		    $tabFiltersWrapper.attr("data-overflowing", determineOverflow($tabFiltersContent, $tabFiltersWrapper));
		});

		$tabFiltersRight.click(function() {
		    if ($tabFiltersSettings.filtersTravelling === true) {
		        return;
		    }

		    if (determineOverflow($tabFiltersContent, $tabFiltersWrapper) === "right" || determineOverflow($tabFiltersContent, $tabFiltersWrapper) === "both") {
		        var filtersRightEdge = $tabFiltersContent[0].getBoundingClientRect().right,
		        	filtersScrollerRightEdge = $tabFiltersWrapper[0].getBoundingClientRect().right,
		        	availableScrollRight = Math.floor(filtersRightEdge - filtersScrollerRightEdge);

		        if (availableScrollRight < $tabFiltersSettings.filtersTravelDistance * 2) {
		            $tabFiltersContent.css('transform', "translateX(-" + availableScrollRight + "px)");
		        } else {
		            $tabFiltersContent.css('transform', "translateX(-" + $tabFiltersSettings.filtersTravelDistance + "px)");
		        }

		        $tabFiltersContent.removeClass('tabs__filters-content-no-transition');
		        $tabFiltersSettings.filtersTravelDirection = "right";
		        $tabFiltersSettings.filtersTravelling = true;
		    }

		    $tabFiltersWrapper.attr("data-overflowing", determineOverflow($tabFiltersContent, $tabFiltersWrapper));
		});

		$tabFiltersContent.bind('transitionend', function() {
		    var tr = $tabFiltersContent.css("-webkit-transform") || $tabFiltersContent.css("transform"),
		    	amount = Math.abs(parseInt(tr.split(",")[4]) || 0);

		    $tabFiltersContent.addClass('tabs__filters-content-no-transition').css('transform', 'none');

		    if ($tabFiltersSettings.filtersTravelDirection === "left") {
		        $tabFiltersWrapper.scrollLeft($tabFiltersWrapper.scrollLeft() - amount);
		    } else {
		        $tabFiltersWrapper.scrollLeft($tabFiltersWrapper.scrollLeft() + amount);
		    }

		    $tabFiltersSettings.filtersTravelling = false;
		});

		function determineOverflow(content, container) {
		    var containerMetrics = container[0].getBoundingClientRect();
		    var containerMetricsRight = Math.floor(containerMetrics.right);
		    var containerMetricsLeft = Math.floor(containerMetrics.left);
		    var contentMetrics = content[0].getBoundingClientRect();
		    var contentMetricsRight = Math.floor(contentMetrics.right);
		    var contentMetricsLeft = Math.floor(contentMetrics.left);

			if (containerMetricsLeft > contentMetricsLeft && containerMetricsRight < contentMetricsRight) {
		        return "both";
		    } else if (contentMetricsLeft < containerMetricsLeft) {
		        return "left";
		    } else if (contentMetricsRight > containerMetricsRight) {
		        return "right";
		    } else {
		        return "none";
		    }
		}
	}
}(jQuery));